import { render } from "./Dashboard.vue?vue&type=template&id=17d3eacd"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentesAzure\\SVRAPPHIR04\\vsts-agent-win-x64-4.261.0\\_work\\6\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__